import { RedoOutlined } from "@ant-design/icons";
import { useStorageActions } from "../../context/storageContext";
import playAgain from "../../assets/play_again.png";
import playAgainHover from "../../assets/play_againHover.png";
import bgResult from "../../assets/bg_result_x_small.png";

const ResponseTimeResults = (props) => {
  const { data } = props;
  const { addResponseScore } = useStorageActions();

  return (
    <div
      style={{
        position: "absolute",
        width: props.width,
        height: props.height,
        // backgroundColor: "#FFFFFF26",
        color: "white",
        fontSize: "large",
        fontWeight: "700",
        zIndex: 2,
      }}
      className="d-flex mb-5 pb-5 flex-column justify-content-center align-items-center"
    >
      <img src={bgResult} alt="bgResult" style={{ position: "absolute" }}></img>
      <div
        className="d-flex flex-column justify-content-start align-items-center text"
        style={{ width: 300, position: "absolute" }}
      >
        <div className="mt-5 pt-3 pb-5" style={{ fontSize: "x-large" }}>
          Result
        </div>
        <div className="d-flex justify-content-between align-items-center pt-2 w-100 mb-3 ">
          <span>Response time </span>
          <span>{props.responseTime}&nbsp; ms</span>
        </div>

        <button
          onClick={props.startGame}
          className=" btn core-button py-1 px-1 mt-1"
        >
          {/* <div className="d-flex  justify-content-center align-items-center">
              <RedoOutlined style={{ fontSize: 36 }} />
              <span className="ml-2">RESTART</span>
            </div> */}
          <img
            src={playAgain}
            onMouseOver={(e) => {
              e.currentTarget.src = playAgainHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = playAgain;
            }}
            alt="play"
          ></img>
        </button>
      </div>
    </div>
  );
};

export default ResponseTimeResults;
